import { action } from 'easy-peasy';
import { IActionSetCrisisReportFilters } from '../types';
import { setCrisisReportFilter } from '~/services/localStorage/filters';

const setCrisisReportFilters: IActionSetCrisisReportFilters = action((state, payload) => {
  const updatedFilters = { ...state.crisisReport.filters, ...payload };

  setCrisisReportFilter(updatedFilters);
  state.crisisReport.filters = updatedFilters;
});

export default setCrisisReportFilters;
